import './TermsConditions.css';
const TermsConditions = () => {
  return (
    <div className="terms-conditions">
      <div className="terms-hero">
        <h1>Terms &amp; Conditions</h1>
        <p>Please read these terms carefully before using RoomBuddy</p>
      </div>
      <div className="terms-content">
        <div className="terms-section">
          <h2>1. Introduction</h2>
          <p>
            By using the RoomBuddy app and services, you agree to follow
            the Terms &amp; Conditions mentioned here. These terms ensure a safe and
            reliable experience for all users.
          </p>
        </div>
        <div className="terms-section">
          <h2>2. Service Usage</h2>
          <p>
            RoomBuddy provides rental discovery and shifting assistance. Users must
            ensure all shared information is accurate and lawful. Misuse of the
            platform may result in account restrictions.
          </p>
        </div>
        <div className="terms-section">
          <h2>3. User Responsibilities</h2>
          <p>
            Users are responsible for verifying property details before final
            booking. RoomBuddy is not responsible for misinformation provided
            by property owners.
          </p>
        </div>
        <div className="terms-section">
          <h2>4. Shifting Service</h2>
          <p>
            Shifting support includes helping, coordination, and guidance. Vehicle
            and packing material charges are payable by the user.
          </p>
        </div>
        <div className="terms-section">
          <h2>5. Cancellations Policy</h2>
          <p>
            RoomBuddy allows customers to cancel scheduled property visits or shifting
            appointments before the confirmed service time.
          </p>
          <p>
            Cancellations must be made prior to the scheduled appointment. Depending on
            the type of service and the service location, applicable service charges may
            be deducted.
          </p>
          <p>
            RoomBuddy reserves the right to modify or cancel bookings due to operational
            or unforeseen circumstances.
          </p>
        </div>
        <div className="terms-section">
          <h2>6. Refund Policy</h2>
          <p>
            RoomBuddy follows a strict no-refund policy on service fees once a booking
            is confirmed.
          </p>
          <p>
            All payments made towards visit bookings, shifting services, or any other
            service charges are non-refundable.
          </p>
        </div>
        <div className="terms-section">
          <h2>7. Data &amp; Privacy</h2>
          <p>
            Your personal data is handled securely. We do not sell or misuse user
            information. Please refer to our{' '}
            <a href="/privacy" style={{ color: '#2563eb', fontWeight: 600 }}>Privacy Policy</a>{' '}
            for full details.
          </p>
        </div>
        <div className="terms-section">
          <h2>8. Liability</h2>
          <p>
            RoomBuddy is not responsible for any loss, dispute, or damage caused
            during property visits or shifting services.
          </p>
        </div>
        <div className="terms-section">
          <h2>9. Changes to Terms</h2>
          <p>
            RoomBuddy may update these terms at any time. Users will be notified
            of major updates inside the app.
          </p>
        </div>
        <div className="terms-section">
          <h2>10. Contact Us</h2>
          <div className="terms-highlight">
            <p>
              For questions or support, email us at{' '}
              <a href="mailto:support@roombuddy.in">support@roombuddy.in</a>
            </p>
          </div>
        </div>
        <div className="terms-updated">
          <span>Last Updated: Dec 11, 2025</span>
        </div>
        <div style={{ textAlign: 'center' }}>
          <a href="/" className="terms-back">← Back to Home</a>
        </div>
      </div>
    </div>
  );
};
export default TermsConditions;